import { AppBar, UserMenu, MenuItemLink, useLogout, useUserMenu } from 'react-admin';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LogoutIcon from '@mui/icons-material/Logout';
import { styled } from '@mui/material/styles';

// ユーザーメニューのスタイル
const StyledMenuItemLink = styled(MenuItemLink)(({ theme }) => ({
	'& .RaMenuItemText-root': {
		color: theme.palette.text.primary,
	},
}));

// プロフィールメニュー
const ProfileMenuItem = () => {
	const userMenu = useUserMenu();
	return (
		<StyledMenuItemLink to="/profile" primaryText="プロフィール" leftIcon={<ManageAccountsIcon />}
			onClick={userMenu?.onClose}
		/>
	);
};

// ログアウトメニュー
const MyLogoutMenuItem = () => {
	const logout = useLogout();
	return (
		<StyledMenuItemLink to="#logout" primaryText="ログアウト" leftIcon={<LogoutIcon />}
			onClick={(e) => {
				e.preventDefault();
				logout();
			}}
		/>
	);
};

// ユーザーメニュー
const MyUserMenu = () => (
	<UserMenu>
		<ProfileMenuItem />
		<MyLogoutMenuItem />
	</UserMenu>
);


// ヘッダーにユーザーメニューを適用
export const MyAppBar = () => {
	return <AppBar userMenu={<MyUserMenu />} />;
};
